import {INavLink} from "data/types/routing";
import {Language} from "data/enums";
import {EN_GAME_ZONE_LINK, GAME_ZONE_URL} from "./routing";

export const subMenuRouting: INavLink[] = [
	{
		title: "sub_header.links.picks",
		href: "/my-picks",
	},
	{
		title: "sub_header.links.rankings",
		href: "/rankings",
		isPrivate: true,
		eventGuid: "fe7cf721-b45d-4b92-a5bb-95575916ce08",
	},
	{
		title: "sub_header.links.leagues",
		href: "/leagues",
		isPrivate: true,
		urls: [
			{
				title: "sub_header.links.my_leagues",
				href: "/leagues",
			},
			{
				title: "sub_header.links.create_league",
				href: "/leagues/create",
			},
			{
				title: "sub_header.links.join",
				href: "/leagues/join",
			},
		],
	},
	{
		title: "sub_header.links.prizes",
		href: "/prizes",
		eventGuid: "87ce9836-7427-4788-a9e4-7a60dd07fee1",
	},
	{
		title: "sub_header.links.help",
		href: "/help",
		eventGuid: "e9915e45-e2f5-4a57-8da0-04388f004684",
	},
	{
		title: "sub_header.links.profile",
		href: `${GAME_ZONE_URL}profile`,
		isPrivate: true,
		isExternal: true,
		eventGuid: "c3126a42-9d69-43bb-bb62-a9d1b9715b39",
	},
];

export const SelectProjectTitle = "sub_header.projects.pickem";

export const subMenuProjectLinksEn = [
	{
		title: "sub_header.projects.gz",
		href: GAME_ZONE_URL,
	},
	{
		title: "sub_header.projects.fantasy",
		href: GAME_ZONE_URL + "fantasy/",
	},
	{
		title: "sub_header.title.futures",
		href: GAME_ZONE_URL + "futures/",
	},
	{
		title: "sub_header.title.team_picker",
		href: GAME_ZONE_URL + "teampicker/",
	},
	{
		title: "sub_header.title.all_star",
		href: GAME_ZONE_URL + "allstar/",
	},
	{
		title: "sub_header.projects.blitzpicks",
		urls: [
			{
				title: "sub_header.projects.blitzpicks_argos",
				href: GAME_ZONE_URL + "blitzpicks/argos/",
			},
			{
				title: "sub_header.projects.blitzpicks_elks",
				href: GAME_ZONE_URL + "blitzpicks/elks/",
			},
			{
				title: "sub_header.projects.blitzpicks_lions",
				href: GAME_ZONE_URL + "blitzpicks/lions/",
			},
			{
				title: "sub_header.projects.blitzpicks_bombers",
				href: GAME_ZONE_URL + "blitzpicks/bombers/",
			},
			{
				title: "sub_header.projects.blitzpicks_riders",
				href: GAME_ZONE_URL + "blitzpicks/riders/",
			},
			{
				title: "sub_header.projects.blitzpicks_redblacks",
				href: GAME_ZONE_URL + "blitzpicks/redblacks/",
			},
			{
				title: "sub_header.projects.blitzpicks_ticats",
				href: GAME_ZONE_URL + "blitzpicks/ticats/",
			},
			{
				title: "sub_header.projects.blitzpicks_stamps",
				href: GAME_ZONE_URL + "blitzpicks/stamps/",
			},
			{
				title: "sub_header.projects.blitzpicks_als",
				href: GAME_ZONE_URL + "blitzpicks/als/",
			},
		],
	},
];

export const subMenuProjectLinksFr = [
	{
		title: "sub_header.projects.gz",
		href: GAME_ZONE_URL,
	},
	{
		title: "sub_header.projects.fantasy",
		href: GAME_ZONE_URL + "fantasy/",
	},
	{
		title: "sub_header.title.futures",
		href: GAME_ZONE_URL + "predictionsavantsaison/",
	},
	{
		title: "sub_header.title.team_picker",
		href: GAME_ZONE_URL + "selectionneurequipe/",
	},
	{
		title: "sub_header.title.all_star",
		href: GAME_ZONE_URL + "etoiles/",
	},
	{
		title: "sub_header.projects.blitzpicks",
		urls: [
			{
				title: "sub_header.projects.blitzpicks_argos",
				href: EN_GAME_ZONE_LINK + "blitzpicks/argos/",
			},
			{
				title: "sub_header.projects.blitzpicks_elks",
				href: EN_GAME_ZONE_LINK + "blitzpicks/elks/",
			},
			{
				title: "sub_header.projects.blitzpicks_lions",
				href: EN_GAME_ZONE_LINK + "blitzpicks/lions/",
			},
			{
				title: "sub_header.projects.blitzpicks_bombers",
				href: EN_GAME_ZONE_LINK + "blitzpicks/bombers/",
			},
			{
				title: "sub_header.projects.blitzpicks_riders",
				href: EN_GAME_ZONE_LINK + "blitzpicks/riders/",
			},
			{
				title: "sub_header.projects.blitzpicks_redblacks",
				href: GAME_ZONE_URL + "blitzpredictions/redblacks/",
			},
			{
				title: "sub_header.projects.blitzpicks_ticats",
				href: EN_GAME_ZONE_LINK + "blitzpicks/ticats/",
			},
			{
				title: "sub_header.projects.blitzpicks_stamps",
				href: EN_GAME_ZONE_LINK + "blitzpicks/stamps/",
			},
			{
				title: "sub_header.projects.blitzpicks_als",
				href: GAME_ZONE_URL + "blitzpredictions/als/",
			},
		],
	},
];

export const subMenuProjectLinks = {
	[Language.English]: subMenuProjectLinksEn,
	[Language.French]: subMenuProjectLinksFr,
};
